import { cls } from "app/utils";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

type proPlanType = "coachpro+monthly" | "coachpro+yearly";

interface PricingToggleProps {
  planCode: "coachpro+monthly" | "coachpro+yearly";
  onPlanSelect: (planCode: proPlanType) => void;
  discount?: string;
  // When given, only these terms can be picked: a re-price offers the terms
  // the subscription may move to.
  availablePlans?: proPlanType[];
}

const PricingToggle: React.FC<PricingToggleProps> = ({
  planCode,
  onPlanSelect,
  discount,
  availablePlans,
}) => {
  const { t } = useTranslation();
  const unavailable = (code: proPlanType) =>
    availablePlans != null && !availablePlans.includes(code);

  return (
    <div className={styles.toggle_container}>
      <button
        className={cls(styles.toggle_button, {
          [styles.active]: planCode === "coachpro+yearly",
          [styles.disabled]: unavailable("coachpro+yearly"),
        })}
        disabled={unavailable("coachpro+yearly")}
        onClick={() => onPlanSelect("coachpro+yearly")}
      >
        {t("Annual")}
        {planCode === "coachpro+yearly" && discount && (
          <span className={styles.discount_badge}>{discount}</span>
        )}
      </button>
      <button
        className={cls(styles.toggle_button, {
          [styles.active]: planCode === "coachpro+monthly",
          [styles.disabled]: unavailable("coachpro+monthly"),
        })}
        disabled={unavailable("coachpro+monthly")}
        onClick={() => onPlanSelect("coachpro+monthly")}
      >
        {t("Monthly")}
      </button>
    </div>
  );
};

export default PricingToggle;
